import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
export default function FreeSupportFilter({
  checked,
  disabled,
  onChange
}) {
  const handleChange = event => {
    onChange(ThemeQueryField.HAS_FREE_SUPPORT, SyntheticEvent(event.target.checked ? true : null));
  };

  return /*#__PURE__*/_jsx(UICheckbox, {
    checked: checked,
    disabled: disabled,
    onChange: handleChange,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.filters.support.optionLabel"
    })
  });
}